<template>
  <span>
    <div v-if="filterUser" class="filter-option">
      Verzonden door
      <users-select
          :disabled="disableFilters"
          :key="userSelectKey"
          appendCssClass="small"
          style="display: inline-block; min-width: 130px;"
          :value="filter.createdByUser"
          @change="setFilterCreatedByUser"
      />
    </div>
    <div v-if="filterBox" class="filter-option">
      Postvak
      <a-select
          :disabled="disableFilters"
          v-model="filter.box"
          style="min-width: 85px;"
          v-on:change="triggerFilter"
          v-on:click.stop
      >
        <a-select-option :value="null">
          In + Uit
        </a-select-option>
        <a-select-option value="in">
          In
        </a-select-option>
        <a-select-option value="out">
          Uit
        </a-select-option>
      </a-select>
    </div>
    <div v-if="filterDateRange" class="filter-option">
      Periode
      <a-range-picker
          :disabled="disableFilters"
          :default-picker-value="[moment().subtract(1, 'months'), moment()]"
          :placeholder="['Startdatum', 'Einddatum']"
          :ranges="{
            'Vorige maand': [
                moment().subtract(1, 'months').startOf('month'),
                moment().subtract(1, 'months').endOf('month')
              ],
            'Deze maand': [
                moment().startOf('month'),
                moment().endOf('month')
              ],
           }"
          format="DD-MM-YYYY"
          style="width: 220px"
          @change="setFilterDateRange">
        <a-icon slot="suffixIcon" type="calendar"/>
      </a-range-picker>
    </div>

    <div v-if="filterSentFrom" class="filter-option">
      <div style="display: flex">
        <span style="vertical-align:middle; line-height: 200%">Verzonden vanaf&nbsp;</span>
        <a-select mode="multiple"
                  :disabled="disableFilters"
                  placeholder="Selecteer een e-mailadres"
                  v-model="filter.sentFrom" style="min-width: 240px"
                  @change="triggerFilter">
          <a-select-option v-for="option in sentFromOptions" :key="option.id" :value="option.address">
            {{ option.address }}
          </a-select-option>
        </a-select>
      </div>
    </div>

    <div v-if="filterSender" class="filter-option">
      <div style="display: flex">
        <span style="vertical-align:middle; line-height: 200%">Afzender&nbsp;</span>
        <a-input
            :disabled="disableFilters"
            v-model="filter.sender"
            :allow-clear="true"
            style="min-width: 130px"
            @input="onTextInput"
            v-on:click.stop
            placeholder="Zoek op e-mailadres"
        />
      </div>
    </div>
    <div v-if="filterReceiver" class="filter-option">
      <div style="display: flex">
        <span style="vertical-align:middle; line-height: 200%">Ontvanger </span>
        <a-input
            :disabled="disableFilters"
            v-model="filter.receiver"
            :allow-clear="true"
            style="min-width: 130px"
            @input="onTextInput"
            v-on:click.stop
            placeholder="Zoek op e-mailadres"
        />
      </div>
    </div>
    <div v-if="filterKeyWord" class="filter-option">
      <div style="display: flex">
        <span style="vertical-align:middle; line-height: 200%">Onderwerp&nbsp;</span>
        <a-input
            :disabled="disableFilters"
            v-model="filter.subject"
            :allow-clear="true"
            style="min-width: 130px"
            @input="onTextInput"
            v-on:click.stop
            placeholder="Zoek op onderwerp"
        />
      </div>
    </div>
    <div class="filter-option">
      <div style="display: flex">
        <a-button :disabled="disableFilters" @click="resetFilter">Verwijder alle filters</a-button>
      </div>
    </div>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import locale from 'ant-design-vue/es/date-picker/locale/nl_NL'
import moment from 'moment'
import debounce from 'lodash/debounce'
import customerApi from '~/api/customer'
import emailAccountApi from '~/api/email_account'
import DateFormatEnum from '~/enums/DateFormatEnum'

export default {
  name: 'EmailOverviewFilterComponent',
  props: {
    customerId: {
      type: [String, Number],
      required: false,
      default: null
    },
    disableFilters: {
      type: Boolean,
      default: false,
    },
    filterUser: { type: Boolean, default: false },
    filterSender: { type: Boolean, default: false },
    filterSentFrom: { type: Boolean, default: false },
    filterReceiver: { type: Boolean, default: false },
    filterBox: { type: Boolean, default: false },
    filterDateRange: { type: Boolean, default: false },
    filterKeyWord: { type: Boolean, default: false },
  },
  data () {
    return {
      locale,
      filter: {
        createdByUser: [],
        dateRange: [],
        box: null,
        subject: null,
        family: null,
        sentFrom: [],
        sender: null,
        receiver: null,
      },
      family: null,
      boxOptions: [
        {
          key: null,
          display: 'In + Uit',
          label: '1'
        },
        {
          key: 'in',
          display: 'In',
          label: '2'

        },
        {
          key: 'out',
          display: 'Uit',
          label: '3'
        }
      ],
      userSelectKey: 1,
      emailAccounts: [],
    }
  },
  mounted () {
    if (this.filterUser) {
      emailAccountApi.getByUser(this.user.id).then(response => {
        this.emailAccounts = response
      })
    }
    if (this.hasCustomer) {
      customerApi.findFamily(this.customerId).then(response => {
        this.family = response.data
      })
    }
  },
  methods: {
    moment,
    setFilterCreatedByUser (value) {
      Object.assign(this.filter.createdByUser, value)
      this.filterRequest()
    },
    triggerFilter () {
      this.filterRequest()
    },
    onTextInput () {
      this.search(this)
    },
    search: debounce((vm) => {
      vm.filterRequest()
    }, 700),
    setFilterDateRange (date) {
      this.filter.dateRange = []
      if (date.length) {
        this.filter.dateRange[0] = date[0].startOf('day').format(DateFormatEnum.ISO8601)
        this.filter.dateRange[1] = date[1].endOf('day').format(DateFormatEnum.ISO8601)
      }
      this.filterRequest()
    },
    filterRequest () {
      this.$emit('filter-request', this.filter)
    },
    resetFilter () {
      this.filter = {
        createdByUser: [],
        dateRange: [],
        box: null,
        subject: null,
        family: null,
        sentFrom: [],
        sender: null,
        receiver: null,
      }
      this.userSelectKey += 1
      this.$emit('filter-request', this.filter)
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    sentFromOptions () {
      return this.emailAccounts !== undefined && this.emailAccounts !== null && this.emailAccounts.filter(o => !this.filter.sentFrom.includes(o))
    },
    hasCustomer () {
      return typeof this.customerId !== 'undefined' && this.customerId !== null
    },
    hasMainCustomer () {
      return typeof this.family !== 'undefined' && this.family !== null && typeof this.family.main !== 'undefined' && this.family.main !== null && typeof this.family.main.data !== 'undefined' && this.family.main.data !== null
    },
    hasPartner () {
      return typeof this.family !== 'undefined' && this.family !== null && typeof this.family.partner !== 'undefined' && this.family.partner !== null && typeof this.family.partner.data !== 'undefined' && this.family.partner.data !== null
    },
    hasChildren () {
      return typeof this.family !== 'undefined' && this.family !== null && typeof this.family.children !== 'undefined' && this.family.children !== null && typeof this.family.children.data !== 'undefined' && this.family.children.data !== null
    },
    mainCustomer () {
      if (this.hasMainCustomer) {
        return this.family.main.data
      }
      return {}
    },
    partner () {
      if (this.hasPartner) {
        return this.family.partner.data
      }
      return {}
    },
    children () {
      if (this.hasChildren) {
        return this.family.children.data
      }
      return {}
    }
  }
}
</script>

<style scoped>
.flex {
  display: flex;
}

.filter-option {
  display: inline-block;
  margin-left: 5px;
  height: 45px
}

/* Doesn't have the desired effect, nor with:  ::v-deep  /deep/  >>>  */
</style>
